import { StepperData } from "@/components/molecules/Progress/FlowSteps/FlowSteps";
import { fakeI18n } from "@/i18n";

export enum InviteFromBrokerSteps {
    CHECK_EMAIL = "choose_broker",
    DEFINE_PASSWORD = "create_account",
    IDENTIFY_ACCOUNT = "identify_account",
}

export const stepperData: StepperData[] = [
    {
        key: InviteFromBrokerSteps.CHECK_EMAIL,
        label: fakeI18n.t("Invite.FlowSteps.Check_Emails"),
    },
    {
        key: InviteFromBrokerSteps.DEFINE_PASSWORD,
        label: fakeI18n.t("Invite.FlowSteps.Create_Account"),
    },
];

export const stepperDataIdentify: StepperData[] = [
    {
        key: InviteFromBrokerSteps.CHECK_EMAIL,
        label: fakeI18n.t("Invite.FlowSteps.Check_Emails"),
    },
    {
        key: InviteFromBrokerSteps.IDENTIFY_ACCOUNT,
        label: fakeI18n.t("Invite.FlowSteps.Identify_Account"),
    },
];
